// FAQ accordion
  document.querySelectorAll('.q button').forEach(function(b){
    b.addEventListener('click',function(){
      var q=b.parentElement, a=q.querySelector('.a');
      var open=q.classList.contains('open');
      if(open){q.classList.remove('open');a.style.maxHeight=null;}
      else{q.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
    });
  });
  // Scroll reveal
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);} });
  },{threshold:0, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  // Sticky add-to-cart: appears at the product section and stays
  (function(){
    var sticky=document.getElementById('sticky'); if(!sticky) return;
    var prod=document.getElementById('autori')||document.getElementById('kit')||document.getElementById('mag5');
    if(!prod){sticky.classList.add('show');return;}
    var so=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ sticky.classList.add('show'); so.disconnect(); } });
    },{threshold:0, rootMargin:'0px 0px -10% 0px'});
    so.observe(prod);
  })();

  // MAG5 product carousel
  (function(){
    var car=document.getElementById('magCar'); if(!car) return;
    var track=car.querySelector('.pcar-track');
    var slides=car.querySelectorAll('.pcar-slide');
    var dots=car.querySelector('.pcar-dots');
    var thumbs=car.querySelector('.pcar-thumbs');
    function goTo(i){track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});}
    slides.forEach(function(_,i){var d=document.createElement('button');if(i===0)d.className='on';d.addEventListener('click',function(){goTo(i);});dots.appendChild(d);});
    if(thumbs){slides.forEach(function(s,i){var img=s.querySelector('img');var b=document.createElement('button');if(i===0)b.className='on';b.setAttribute('aria-label','Vai all\'immagine '+(i+1));var ti=document.createElement('img');ti.src=img?img.getAttribute('src'):'';ti.loading='lazy';ti.alt=img?(img.getAttribute('alt')||''):'';b.appendChild(ti);b.addEventListener('click',function(){goTo(i);});thumbs.appendChild(b);});}
    function cur(){return Math.round(track.scrollLeft/track.clientWidth);}
    function upd(){var c=cur();dots.querySelectorAll('button').forEach(function(b,i){b.classList.toggle('on',i===c);});if(thumbs){thumbs.querySelectorAll('button').forEach(function(b,i){b.classList.toggle('on',i===c);});}}
    track.addEventListener('scroll',function(){window.requestAnimationFrame(upd);});
    car.querySelector('.prev').addEventListener('click',function(){track.scrollTo({left:track.clientWidth*Math.max(0,cur()-1),behavior:'smooth'});});
    car.querySelector('.next').addEventListener('click',function(){track.scrollTo({left:track.clientWidth*Math.min(slides.length-1,cur()+1),behavior:'smooth'});});
  })();

  // upsell modal: shown on first add-to-cart click
  (function(){
    var ov=document.getElementById('upsell'); if(!ov) return;
    var shown=false;
    function open(){ov.classList.add('show');shown=true;}
    function close(){ov.classList.remove('show');}
    document.querySelectorAll('a.btn[data-cta]').forEach(function(b){
      b.addEventListener('click',function(e){ e.preventDefault(); open(); });
    });
    ov.querySelectorAll('[data-uclose]').forEach(function(x){x.addEventListener('click',close);});
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    var acc=ov.querySelector('[data-uaccept]'); if(acc){acc.addEventListener('click',function(e){e.preventDefault();close();});}
  })();